import React, { useState, useEffect } from "react";
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";
import { CgSpinner } from "react-icons/cg";
import { useNavigate } from "react-router-dom";

const CardDetailsForm = ({
  setRenderOpen,

  setIsPlanShow,

  isStripeOpen,
  setisStripeOpen,
  setIsOpen,

  selectedPlan,
  getTime,
  
  cardDetails,
  card,
  setCard,
  
  coupanName,
  setCoupanName,
  couponLoading,
  coupanError,
  setCoupanError,
  handleChange,
  handleDiscount,
  
  setLoading,
  makePayment,
  
  setIsSuccessOpen,
  openNewTab,
}) => {
  // console.log('4 CardDetailsForm');
 const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [zipCode, setZipCode] = useState(card?.zipcode || "");
  const [email, setEmail] = useState(card?.email || "");

  // console.log(email);

  const [stripeElementsComplete, setStripeElementsComplete] = useState({
    cardNumber: false,
    cardExpiry: false,
    cardCvc: false,
  });

  const stripe = useStripe();
  const elements = useElements();
  const userInfo = JSON.parse(localStorage.getItem("user")) || {};

  // When zipCode changes, update parent card state
  useEffect(() => {
    if (card && setCard) {
      setCard((prev) => ({ ...prev, zipcode: zipCode }));
    }
  }, [zipCode, setCard]);

  // When email changes, update parent card state
  useEffect(() => {
    if (card && setCard) {
      setCard((prev) => ({ ...prev, email: email }));
    }
  }, [email, setCard]);

  // Initialize email from userInfo if available
  useEffect(() => {
    if (userInfo && userInfo.email && !email) {
      setEmail(userInfo.email);
    }
  }, [userInfo]);

  // Update stripeElementsComplete state when card changes
  useEffect(() => {
    if (card) {
      setStripeElementsComplete({
        cardNumber: card.cardNumber || false,
        cardExpiry: card.cardExpiry || false,
        cardCvc: card.cardCvc || false,
      });
    }
  }, [card]);

  // Handle changes in Stripe elements
  const handleStripeElementChange = (event) => {
    // Update local state
    setStripeElementsComplete((prev) => ({
      ...prev,
      [event.elementType]: event.complete,
    }));

    // Update parent card state
    if (setCard) {
      setCard((prev) => ({
        ...prev,
        [event.elementType]: event.complete,
      }));
    }

    setError("");
  };

  // Handle changes in regular form inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "zipcode") {
      const formattedZip = value.replace(/\D/g, "").slice(0, 5);
      setZipCode(formattedZip);
    } else if (name === "email") {
      setEmail(value);
    }
  };

  // Form submission handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // toast.error("Stripe has not been initialized");
      toast(<CustomToast title="" content="Stripe has not been initialized"/>, defaultcustomToatStyle);
      return;
    }

    if (!isFormValid()) {
      toast(<CustomToast title="" content="Please fill all required fields correctly"/>, defaultcustomToatStyle);
      toast.error("Please fill all required fields correctly");
      console.log("Form validation failed:", {
        stripeElements: stripeElementsComplete,
        zipCode,
        email,
        isValid: isFormValid(),
      });
      return;
    }

    setIsProcessing(true);

    try {
      const { error: paymentMethodError, paymentMethod } =
        await stripe.createPaymentMethod({
          type: "card",
          card: elements.getElement(CardNumberElement),
          billing_details: {
            email: email,
            address: {
              postal_code: zipCode,
            },
          },
        });
      

      if (paymentMethodError) {
        toast.error(paymentMethodError.message || "Payment failed");
        toast(<CustomToast title="Payment failed" content={` ${paymentMethodError.message}`}/>, defaultcustomToatStyle);
        setIsProcessing(false);
        return;
      }

      const paymentRes = await makePayment(paymentMethod);

      console.log('3 Upgrade-Now makePayment paymentRes = ',paymentRes);

      if (paymentRes.success) {
        console.log('paymentRes.success')
        const { client_secret, stripe_status } = paymentRes.newRecurring;

        if (stripe_status === "requires_action") {
          const { error: confirmError } = await stripe.confirmCardPayment(
            client_secret
          );
          if (confirmError) throw confirmError;
        }
        navigate('/paymentsuccess');
        // toast(<CustomToast title="" content="Payment Success hiuhiou9g" />, defaultcustomToatStyle);
        handlePaymentSuccess();
      }
    } catch (err) { 
      // toast(<CustomToast title="" content="Payment Failed" />, defaultcustomToatStyle);
    } finally {      
      setIsProcessing(false);
    }
  };

  // Handle successful payment
  const handlePaymentSuccess = () => {
    console.log(' handlePaymentSuccess and Redirect ')
    navigate('/paymentsuccess') 
    setLoading(false);
    toast(<CustomToast title="" content="Payment Success handlePaymentSuccess" />, defaultcustomToatStyle);
    resetState();
    openNewTab();      
  };

  // Reset all related states
  const resetState = () => {
    setIsSuccessOpen(true);
    getTime(); 
    setCard(cardDetails);
    setIsOpen(false);
    setisStripeOpen(false);
    // setStripeOpen(false);
    setCoupanName("");
    setCoupanError("");
    setRenderOpen(false);
    // IsUpgradeOpen(false);
    setIsPlanShow(false)
  };

  // Handle modal close
  const handleClose = () => {
    setisStripeOpen(false);
    setCard(cardDetails);
  };

  // Check if form is valid for submission
  const isFormValid = () => {
    const stripeValid =
      stripeElementsComplete.cardNumber &&
      stripeElementsComplete.cardExpiry &&
      stripeElementsComplete.cardCvc;
    const zipValid = zipCode.length >= 5;
    const emailValid = email && email.includes("@");

    return stripeValid && zipValid && emailValid;
  };

  return (
    <>
      <div className="p-4 text-gray-700 "> 
        <div className="p-4 text-gray-700 w-full">
          <div className="mb-4 flex flex-col gap-2">
            <h3 className="lg:text-[1.8rem] text-[1.5rem] font-semibold text-white">Payment Details</h3>
            <h4 className="text-[0.8rem] text-gray-300 font-normal">Fill in your card information to complete your order.</h4>
          </div>

          <form className="space-y-6 border-b-[1px] border-gray-700 pb-8" onSubmit={handleSubmit}>
            <div className="border border-gray-500 rounded-lg overflow-hidden">
              {/* Card Number */}
              <div className="p-2 transition-all border-b border-gray-500 shadow-sm">
                <CardNumberElement onChange={handleStripeElementChange} options={{style: {base: {fontSize: "15px", color: "#fff"}}}} className="w-full"/>
              </div>

              {/* Expiry and CVC - Compact */}
              <div className="grid grid-cols-2 gap-3 border-b border-gray-500">
                <div className="p-2 shadow-sm border-r border-gray-500">
                  <CardExpiryElement onChange={handleStripeElementChange} options={{style: { base: { fontSize: "15px", color: "#fff" } }}}/>
                </div>
                <div className="rounded-md p-2 shadow-sm">
                  <CardCvcElement onChange={handleStripeElementChange} options={{style: { base: { fontSize: "15px", color: "#fff" } }}}/>
                </div>
              </div>

              {/* Zip Code */}
              <input className="w-full placeholder:bg-[#1e1f2a] placeholder:text-gray-400 border-b border-gray-500 bg-[#1e1f2a] p-2 text-gray-100 outline-none text-sm"
                name="zipcode" value={zipCode} onChange={handleInputChange} placeholder="Billing Zipcode" inputMode="numeric" required
              />

              {/* Email */}
              <input className="w-full placeholder:bg-[#1e1f2a] bg-[#1e1f2a] p-2 outline-none text-sm text-gray-400"
                name="email" value={email} onChange={handleInputChange} disabled
              />
            </div>

            {/* Error Message */}
            {error && <div className="text-red-500 text-xs mt-1">{error}</div>}

            {/* Promo Code & Apply Button */}
            <div className="flex justify-between flex-col gap-2">
              <div className="flex justify-between gap-3">
                <input className="w-1/2 placeholder:text-gray-400 border border-gray-500 bg-[#1e1f2a] py-1 px-2 text-gray-100 outline-none text-sm rounded-lg"
                  placeholder="Promo code" onChange={handleChange} value={coupanName}
                />
                <div className="cursor-pointer w-1/2 flex gap-2 items-center justify-center py-1 rounded-lg border border-gray-800 text-gray-100 bg-gray-900 hover:bg-gray-800 transition-colors duration-200 font-normal"
                  onClick={handleDiscount}
                >
                  Apply
                  {couponLoading && (<CgSpinner className="animate-spin text-[0.7rem]" />)}
                </div>
              </div>

              <div>
                {coupanError !=="The coupon has been successfully applied." && (<p className="text-red-500 text-[0.6rem]">{coupanError}</p>)}
                {coupanError ==="The coupon has been successfully applied." && (<p className="text-green-500 text-[0.6rem]">{coupanError}</p>)}
              </div>
            </div>

            {/* Submit Button */}
            <button className="w-full  flex justify-center items-center bg-gradient-to-r from-[#4f44c2] via-[#6458b8] to-[#6c61b3] text-white font-medium py-2 px-4 rounded-md transition-colors text-sm"
              type="submit" disabled={!isFormValid() || isProcessing}
              style={{cursor: !isFormValid() ? '' : 'cursor-pointer'}}
            >
              {isProcessing ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                  </svg>
                  Processing...
                </>
              ) : ("Upgrade Now")
              }
            </button>
          </form>

          {/* Security Message */}
          <div className="text-center text-xs text-gray-500 pt-3">
            <p className="font-semibold py-1">Powered by <span className="text-purple-500">Stripe</span></p>

            <div className="flex items-center justify-center">
              <svg className="w-4 h-4 text-green-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
              </svg>
              <p>Secured with 256-bit SSL encryption</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardDetailsForm;
